module.exports = __webpack_public_path__ + "static/media/Room types unlimited.52bce038.svg";